import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Link from "next/link";
import { useUsedCarsData } from "../../hooks/use-used-cars-data/use-used-cars-data";
export const UsedCarsDataTempComponent = ()=>{
    const { isValidating , isLoading , usedCarsApiError , searchResults , searchParams , setPageNumber , getUrlForPageNumber  } = useUsedCarsData();
    const currentPageNumber = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.pageNumber) ?? 1;
    const handlePageButtonClicked = (direction)=>()=>{
            const pageOffset = direction === "next" ? 1 : -1;
            setPageNumber(Math.max(1, currentPageNumber + pageOffset));
        };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            "useUsedCarsData hook testing - dev only",
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        onClick: handlePageButtonClicked("prev"),
                        children: "Previous page"
                    }),
                    currentPageNumber,
                    /*#__PURE__*/ _jsx("button", {
                        onClick: handlePageButtonClicked("next"),
                        children: "Next page"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    "searchParams: ",
                    /*#__PURE__*/ _jsx("pre", {
                        children: JSON.stringify(searchParams, null, 2)
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    "isValidating: ",
                    isValidating ? "true" : "false"
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    "isLoading: ",
                    isLoading ? "true" : "false"
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    "usedCarsApiError: ",
                    /*#__PURE__*/ _jsx("pre", {
                        children: usedCarsApiError
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    "Pages:",
                    /*#__PURE__*/ _jsx(Link, {
                        href: getUrlForPageNumber(1),
                        children: "1"
                    }),
                    /*#__PURE__*/ _jsx(Link, {
                        href: getUrlForPageNumber(2),
                        children: "2"
                    }),
                    /*#__PURE__*/ _jsx(Link, {
                        href: getUrlForPageNumber(3),
                        children: "3"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    "searchResults: ",
                    /*#__PURE__*/ _jsx("pre", {
                        children: JSON.stringify(searchResults, null, 2)
                    })
                ]
            })
        ]
    });
};
